import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/features/template/store";
import { getLinerConfigByFieldName } from "../app/features/dashboard/actions/instruction";

interface LinerConfig { [key: string]: any; }

export const useLinerConfig = (
  country: string,
  linerId: string,
  instructionId: number | string,
  type: string | null = null,
  location: string | null = null
): LinerConfig => {
  const dispatch = useDispatch<AppDispatch>();
  const fetchedRef = useRef<Record<string, boolean>>({});

  const configKey = `${country}_${linerId}_${instructionId}_${location}_${type}`;

  const config = useSelector(
    (state: RootState) => state.instructionSlice.linerConfig
  )?.[configKey];

  useEffect(() => {
    if (!country || !linerId) return;
    if (config) return;
    if (fetchedRef.current[configKey]) return;

    fetchedRef.current[configKey] = true;

    dispatch(
      getLinerConfigByFieldName({
        linerId,
        country,
        location: location,
        instructionId,
        configKey,
        type
      })
    );
  }, [country, linerId,location, config, configKey, type]);

  return config ?? {};
};
